module.exports = __webpack_public_path__ + "static/media/project_placeholder.1a88de28.svg";